import React from 'react';
import { CircleIconBoxWithTitle, DiscountedPrice } from './WmwComp';
import monitor from '../img/circle-monitor.png';
import shield from '../img/circle-shield.png';
import notebook from '../img/circle-notebook.png';
import { ChurchschoolPrices } from '../../homeschool/ChurchschoolPriceContext';

const WmwSection13 = ({ prices }: { prices: ChurchschoolPrices }) => {
  return (
    <div className="flex justify-center bg-gradient-to-b from-[#ffffff] from-20% to-[#3700B3] p-3 py-10 md:p-12 md:py-20">
      <div className="flex w-full max-w-[520px] flex-col items-center justify-center gap-10 md:gap-12">
        {/* 타이틀 */}
        <div className="text-center font-['Pretendard'] text-3xl font-bold leading-tight md:text-4xl md:leading-snug">
          교사 코스는
          <br />
          이렇게 구성되어 있어요!
        </div>

        {/* 컨텐츠 */}
        <div className="flex flex-col gap-3 md:gap-5">
          {/* 교사 메인코스 3년 */}
          <div
            className="flex w-full flex-col items-center justify-center overflow-hidden rounded-lg shadow"
            style={{ boxShadow: '0px 0px 3px 2px rgba(150,150,150,0.3)' }}
          >
            <div className="w-full bg-[#31099F] p-2 text-center text-lg font-bold text-[#FFDA19] md:text-xl">
              메인 교사용
            </div>

            <div className="flex w-full flex-col items-center justify-center gap-5 bg-[#F5F4FF] p-5">
              <div className="flex items-center justify-center gap-5 md:gap-7">
                <CircleIconBoxWithTitle
                  icon={monitor}
                  circleColor="bg-[#31099F]"
                  circleSize="h-20 w-20 md:h-28 md:w-28"
                  title={
                    <div className="whitespace-nowrap text-sm md:text-xl">
                      온라인 교육과정
                    </div>
                  }
                  delay={0.1}
                />

                <CircleIconBoxWithTitle
                  icon={shield}
                  circleColor="bg-[#31099F]"
                  circleSize="h-20 w-20 md:h-28 md:w-28"
                  title={
                    <div className="whitespace-nowrap text-sm md:text-xl">
                      온라인 자료{' '}
                      <span className="font-bold text-[#31099F]">3년</span>
                    </div>
                  }
                  delay={0.3}
                />
                <CircleIconBoxWithTitle
                  icon={notebook}
                  circleColor="bg-[#31099F]"
                  circleSize="h-20 w-20 md:h-28 md:w-28"
                  title={
                    <div className="whitespace-nowrap text-sm md:text-xl">
                      교재{' '}
                      <span className="font-bold text-[#31099F]">3년치</span>
                    </div>
                  }
                  delay={0.5}
                />
              </div>

              <DiscountedPrice
                price={prices.wmw.main.original}
                discountedPrice={prices.wmw.main.discount}
                discountColor="text-[#31099F]"
              />
            </div>
          </div>

          {/* 교사 메인코스 1년 */}
          <div
            className="flex w-full flex-col items-center justify-center overflow-hidden rounded-lg"
            style={{
              boxShadow: '0px 0px 10px 2px rgba(150,150,150,0.3 )',
            }}
          >
            <div className="w-full bg-gray6 p-2 text-center text-lg font-bold text-[#FFDA19] md:text-xl">
              서브 교사용
            </div>

            <div className="flex w-full flex-col items-center justify-center gap-5 bg-[#F5F4FF] p-5">
              <div className="flex items-center justify-center gap-5 md:gap-7">
                <CircleIconBoxWithTitle
                  icon={monitor}
                  circleColor="bg-[#d9d9d9]"
                  circleSize="h-20 w-20 md:h-28 md:w-28"
                  title={
                    <div className="text-sm md:text-xl">온라인 교육과정</div>
                  }
                  delay={0.1}
                />

                <CircleIconBoxWithTitle
                  icon={shield}
                  circleColor="bg-[#d9d9d9]"
                  circleSize="h-20 w-20 md:h-28 md:w-28"
                  title={
                    <div className="text-sm md:text-xl">
                      온라인 자료{' '}
                      <span className="font-bold text-gray7">1년</span>
                    </div>
                  }
                  delay={0.3}
                />
                <CircleIconBoxWithTitle
                  icon={notebook}
                  circleColor="bg-[#d9d9d9]"
                  circleSize="h-20 w-20 md:h-28 md:w-28"
                  title={
                    <div className="text-sm md:text-xl">
                      교재 <span className="font-bold text-gray7">1년치</span>
                    </div>
                  }
                  delay={0.5}
                />
              </div>

              <DiscountedPrice
                price={prices.wmw.sub.original}
                discountedPrice={prices.wmw.sub.discount}
                discountColor="text-gray7"
              />
            </div>
          </div>

          <div className="text-center text-xs text-white md:text-base">
            * 본 코스의 메인교사가 최소 1명 이상인 교회만 서브교사를 추가할 수
            있습니다.
            <br />* 기간 종료 후 1년 단위 연장이 가능합니다. (연 6만원)
          </div>
        </div>

        <div className="text-center text-xl font-normal leading-tight text-white md:text-3xl md:leading-snug">
          젭스 온라인 교사대학은
          <br />
          <span className="font-bold">
            영어실력과 관계없이
            <br />
            건강한 교회에 속한 교인이라면
            <br /> 누구나 수강 가능해요!
          </span>
        </div>
      </div>
    </div>
  );
};

export default WmwSection13;
